import { fromJS } from 'immutable'
import { actions } from './actions'

const initialState = {
    homePageContent: {},
    lastHomePageFetched: null,
    getHomePageItemsInProgress: false,

    categoriesDetails: [],
    subCategoryItems: [],
    selectedSubCategory: '',
    subCategoryAllItems: [],

    categoryFilters: [],
    subCategoryFilters: [],
    filtersProcessing: false,
    appliedCategoryFilter: [],

    gettingProductDetails: false,
    productDetails: null,
    productDetailsById: null,

    productSearchResults: { Items: [] },
    searchingProducts: false,

    gettingSearchedProduct: false,
    searchedValue: '',
    searchedProduct: null,

    productLoadResults: { Items: [] },
    loadingProducts: false,
    gettingProductDetailsFailed: false,
    detailsPageLoading: true,
    localizedProductSubCategoryName: '',

    getStoreIdProgress: false,
    storeId: null,
    getHomePageCategoriesInProgress: false,

    cateringProducts: [],
    cateringFilterProcessing: false,
    cateringFilters: [],
    subCateringFilters: [],
    subCateringAllItems: [],

    cateringSchedule: {
        date: null,
        time: null,
        isValid: false,
    },
}

export default (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.GET_HOME_PAGE_ITEMS: {
            return { ...state, getHomePageItemsInProgress: true }
        }

        case actions.GET_HOME_PAGE_ITEMS_SUCCESS: {
            return {
                ...state,
                homePageContent: payload,
                lastHomePageFetched: Date.now(),
                getHomePageItemsInProgress: false,
            }
        }

        case action.SET_LAST_HOME_PAGE_FETCH: {
            return { ...state, lastHomePageFetched: fromJS(payload) }
        }

        case actions.GET_HOME_PAGE_ITEMS_FAILED_DONE: {
            return { ...state, getHomePageItemsInProgress: false }
        }

        case actions.REMOVE_HOME_PAGE_ITEMS: {
            return { ...state, homePageContent: {} }
        }
        case actions.GET_HOME_PAGE_CATEGORIES_LIST: {
            return { ...state, getHomePageCategoriesInProgress: true }
        }

        case actions.GET_HOME_PAGE_CATEGORIES_ITEMS_SUCCESS: {
            let _homepageContent = state.homePageContent
            if (_homepageContent) _homepageContent = {}
            if (payload) {
                Object.keys(payload).forEach(key => {
                    _homepageContent[key] = payload[key]
                })
            }
            return {
                ...state,
                homePageContent: _homepageContent,
                lastHomePageFetched: Date.now(),
                getHomePageCategoriesInProgress: false,
            }
        }

        case actions.GET_HOME_PAGE_CATEGORIES_ITEMS_FAILED_DONE: {
            return { ...state, getHomePageCategoriesInProgress: false }
        }

        case actions.GET_SUB_CATEGORIES: {
            return { ...state, filtersProcessing: true }
        }

        case actions.SUB_CATEGORIES_SUCCESS: {
            const { categoriesDetails } = state
            categoriesDetails.push(action.transformedPayload)
            return {
                ...state,
                filtersProcessing: false,
                subCategoryItems: action.transformedPayload,
                categoriesDetails,
                subCategory: payload,
            }
        }

        case actions.SUB_CATEGORIES_FAILED: {
            return { ...state, filtersProcessing: false }
        }

        case actions.GET_CATEGORY_FILTERS:
        case actions.GET_SUB_CATEGORY_FILTERS: {
            return {
                ...state,
                filtersProcessing: true,
            }
        }

        case actions.GET_SUB_CATERING_FILTERS: {
            return {
                ...state,
            }
        }

        case actions.GET_CATERING_FILTERS: {
            return {
                ...state,
            }
        }

        case actions.REMOVE_CATEGORY_FILTERS: {
            return {
                ...state,
                categoryFilters: [],
            }
        }

        case actions.REMOVE_CATERING_FILTERS: {
            return {
                ...state,
                cateringFilters: [],
            }
        }

        case actions.REMOVE_SUB_CATEGORY_FILTERS: {
            return {
                ...state,
                subCategoryFilters: [],
            }
        }

        case actions.REMOVE_SUB_CATERING_FILTERS: {
            return {
                ...state,
                subCateringFilters: [],
            }
        }

        case actions.GET_CATEGORY_FILTERS_SUCCESS: {
            return {
                ...state,
                categoryFilters: payload.filters,
            }
        }
        case actions.GET_CATERING_FILTERS_SUCCESS: {
            return {
                ...state,
                cateringFilters: payload.filters,
            }
        }

        case actions.GET_SUB_CATEGORY_FILTERS_SUCCESS: {
            return {
                ...state,
                subCategoryFilters: payload.filters,
            }
        }

        case actions.GET_SUB_CATERING_FILTERS_SUCCESS: {
            return {
                ...state,
                subCateringFilters: payload.filters,
            }
        }

        case actions.FILTERS_FAILED: {
            return {
                ...state,
                filtersProcessing: false,
                cateringFilterProcessing: false,
            }
        }

        case actions.APPLY_CATEGORY_FILTERS: {
            return {
                ...state,
                filtersProcessing: true,
            }
        }

        case actions.APPLY_CATEGORY_FILTERS_SUCCESS: {
            return {
                ...state,
                subCategoryItems: payload,
                filtersProcessing: false,
            }
        }

        case actions.APPLY_CATERING_FILTERS:{
            return {
                ...state,
                cateringProducts: [],
                cateringFilterProcessing: true,
            }
        }

        case actions.APPLY_CATERING_FILTERS_SUCCESS:{
            return {
                ...state,
                cateringProducts: payload,
                cateringFilterProcessing: false,
            }
        }

        
        case actions.APPLY_SUB_CATERING_FILTERS: {
            return {
                ...state,
                cateringFilterProcessing: true,
            }
        }

        case actions.APPLY_SUB_CATEGORY_FILTERS_SUCCESS: {
            return {
                ...state,
                subCategoryAllItems: payload,
                filtersProcessing: false,
            }
        }

        case actions.APPLY_SUB_CATERING_FILTERS_SUCCESS: {
            return {
                ...state,
                subCateringAllItems: payload,
                cateringFilterProcessing: false,
            }
        }

        case actions.REMOVE_APPLIED_CATEGORY_FILTERS: {
            return {
                ...state,
                subCategoryItems: [],
            }
        }

        case actions.REMOVE_APPLIED_SUB_CATEGORY_FILTERS: {
            return {
                ...state,
                subCategoryAllItems: [],
            }
        }

        case actions.REMOVE_APPLIED_CATERING_FILTERS: {
            return {
                ...state,
                cateringProducts: [],
            }
        }

        case actions.REMOVE_APPLIED_SUB_CATERING_FILTERS: {
            return {
                ...state,
                subCateringAllItems: [],
            }
        }

        case actions.GET_PRODUCT_DETAILS: {
            return {
                ...state,
                gettingProductDetails: true,
                productDetails: null,
                searchedProduct: null,
                gettingProductDetailsFailed: false,
            }
        }

        case actions.GET_PRODUCT_DETAILS_SUCCESS: {
            return {
                ...state,
                gettingProductDetails: false,
                productDetails: payload,
                gettingProductDetailsFailed: false,
                detailsPageLoading: false,
            }
        }

        case actions.GET_PRODUCT_DETAILS_FAILED: {
            return {
                ...state,
                gettingProductDetails: false,
                productDetails: null,
                gettingProductDetailsFailed: true,
                detailsPageLoading: false,
            }
        }

        case actions.GET_PRODUCT_DETAILS_BY_ID_SUCCESS: {
            return {
                ...state,
                gettingProductDetailsById: false,
                productDetailsById: payload,
                gettingProductDetailsByIdFailed: false,
            }
        }

        case actions.GET_PRODUCT_DETAILS_BY_ID_FAILED: {
            return {
                ...state,
                gettingProductDetailsById: false,
                productDetailsById: null,
                gettingProductDetailsByIdFailed: true,
            }
        }

        case actions.SEARCH_PRODUCTS: {
            const { productSearchResults } = state

            return {
                ...state,
                productSearchResults: {
                    ...productSearchResults,
                    Items: payload.lastKey ? productSearchResults.Items : [],
                },
                searchingProducts: true,
            }
        }
        case actions.DETAILS_PAGE_LOADING: {
            return {
                ...state,
                detailsPageLoading: action.payload,
            }
        }

        case actions.RESET_SEARCH_PRODUCTS: {
            const { productSearchResults } = state

            return {
                ...state,
                productSearchResults: {
                    ...productSearchResults,
                    Items: [],
                },
            }
        }

        case actions.SEARCH_PRODUCTS_SUCCESS: {
            const { productSearchResults } = state

            const mergeObj = {
                ...productSearchResults,
                Items: [...productSearchResults.Items, ...payload.Items],
            }
            if (payload.LastEvaluatedKey && payload.LastEvaluatedKey.id) {
                mergeObj.LastEvaluatedKey = payload.LastEvaluatedKey
            } else {
                delete mergeObj.LastEvaluatedKey
            }
            return {
                ...state,
                productSearchResults: mergeObj,
                searchingProducts: false,
            }
        }

        case actions.SEARCH_PRODUCTS_FAILED: {
            return { ...state, searchingProducts: false, detailsPageLoading: false }
        }

        case actions.LOAD_PRODUCTS: {
            return {
                ...state,
                productLoadResults: { Items: [] },
                loadingProducts: true,
                searchedProduct: null,
                productDetails: null,
            }
        }

        case actions.LOAD_PRODUCTS_SUCCESS: {
            return {
                ...state,
                productLoadResults: payload,
                loadingProducts: false,
            }
        }

        case actions.LOAD_PRODUCTS_FAILED: {
            return { ...state, loadingProducts: false }
        }

        case actions.GET_SEARCHED_PRODUCT: {
            return {
                ...state,
                gettingSearchedProduct: true,
                searchedProduct: null,
            }
        }

        case actions.GET_SEARCHED_PRODUCT_SUCCESS: {
            return {
                ...state,
                gettingSearchedProduct: false,
                searchedProduct: payload,
            }
        }

        case actions.GET_SEARCHED_PRODUCT_FAILED: {
            return {
                ...state,
                gettingSearchedProduct: false,
                searchedProduct: null,
            }
        }

        case actions.SET_SEARCHED_VALUE: {
            return {
                ...state,
                searchedValue: payload,
            }
        }

        case actions.CLEAR_PRODUCTS: {
            return {
                ...state,
                searchedProduct: null,
                productDetails: null,
            }
        }

        case actions.SET_SELECTED_SUB_CATEGORY: {
            return {
                ...state,
                selectedSubCategory: payload,
            }
        }
        case actions.SET_LOCALIZED_PRODUCT_SUB_CATEGORY_NAME: {
            return {
                ...state,
                localizedProductSubCategoryName: payload,
            }
        }

        case actions.GET_STORE_ADDRESS: {
            return {
                ...state,
                getStoreIdProgress: true,
            }
        }

        case actions.GET_STORE_ADDRESS_SUCCESS: {
            return {
                ...state,
                storeId: payload,
                getStoreIdProgress: false,
            }
        }

        case actions.GET_STORE_ADDRESS_FAILED: {
            return {
                ...state,
                getStoreIdProgress: false,
            }
        }

        case actions.SET_CATERING_SCHEDULE: {
            const { date, time } = payload
            return {
                ...state,
                cateringSchedule: {
                    date,
                    time,
                    isValid: !!(date && time),
                },
            }
        }

        case actions.CLEAR_CATERING_SCHEDULE: {
            return {
                ...state,
                cateringSchedule: {
                    date: null,
                    time: null,
                    isValid: false,
                },
            }
        }

        default:
            return state
    }
}
